<script setup lang="ts">
import GoogleButton from "@/common/components/GoogleButton.vue"
import ModalWithButtons from "@/common/components/ModalWithButtons.vue"
import MsButton from "@/common/components/MsButton.vue"
import Description from "@/common/global-components/texts/Description.vue"
import { auth, authMs } from "@/common/helpers/auth"
import { ref } from "vue"

const show = ref(false)
</script>

<template>
  <div @click="show = true">
    <slot />
  </div>
  <div v-if="show">
    <modal-with-buttons @close="show = false">
      <template #title>カレンダーと連携する</template>
      <template #description>
        <strong-g class="lo-v-end">
          <Description><a href="https://site.nitte.app" target="_blank">Nitte</a>に登録してカレンダーと連携すると、候補日時の予定を確認できます。</Description>
        </strong-g>
      </template>
      <template #contents>
        <!-- Sample preview -->
        <div class="sample-preview">
          <div class="sample-header">
            <span class="sample-header-label">候補日時</span>
            <span class="sample-linked">連携中</span>
          </div>
          <div class="sample-list">
            <div class="sample-item sample-free">
              <div class="sample-item-text"><span class="sample-time">14:00-15:00</span></div>
              <span class="sample-chip chip-free">空き ○</span>
              <span class="sample-cal-icon"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M5 1v2M11 1v2M1 6h14M3 3h10a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2V5a2 2 0 012-2z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </div>
            <div class="sample-item sample-busy">
              <div class="sample-item-text"><span class="sample-time">15:00-16:00</span></div>
              <span class="sample-chip chip-busy">A社商談 ×</span>
              <span class="sample-cal-icon"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M5 1v2M11 1v2M1 6h14M3 3h10a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2V5a2 2 0 012-2z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </div>
            <div class="sample-item sample-partial">
              <div class="sample-item-text"><span class="sample-time">16:00-18:00</span></div>
              <span class="sample-chip chip-partial">一部空き</span>
            </div>
          </div>
        </div>

        <section class="lo-v-center">
          <google-button @click="auth" class="regist-button mg-top-16px">Googleでログイン</google-button>
          <ms-button @click="authMs" class="regist-button mg-top-12px">
            Microsoftでログイン
          </ms-button>
          <sup-description class="mg-top-8px">
            <span>ログインすることで、</span>
            <a href="https://site.nitte.app/terms">
              <span>利用規約</span>
            </a>
            <span>、</span>
            <a href="https://site.nitte.app/privacy">
              <span>プライバシーポリシー</span>
            </a>
            <span>に同意するものとします。</span>
            <span>
              セキュリティについて詳しくは
              <a href="https://site.nitte.app/security" target="_blank">こちら</a>
            </span>
          </sup-description>
        </section>
      </template>
    </modal-with-buttons>
  </div>
</template>

<style scoped>
.regist-button {
  width: 250px;
}
/* Sample preview */
.sample-preview {
  margin: 16px 0 12px;
  border: 1px solid var(--border-gray);
  border-radius: 10px;
  padding: 16px 18px;
  background: var(--bg-screen);
}
.sample-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.sample-header-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--font-gray-2);
}
.sample-linked {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--main);
}
.sample-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.sample-list {
  gap: 6px;
}
.sample-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
}
.sample-free { background: #f4f9ee; }
.sample-busy { background: #fdf2f2; }
.sample-partial { background: #fffdf5; }
.sample-item-text {
  flex: 1;
  min-width: 0;
}
.sample-time {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--font-black);
}
.sample-chip {
  font-size: 0.75rem;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}
.chip-free { background: #EAF3DE; color: #3B6D11; }
.chip-busy { background: #FCEBEB; color: #A32D2D; }
.chip-partial { background: #FFF8E1; color: #8D6E00; }
.sample-cal-icon {
  color: var(--font-gray-3);
  flex-shrink: 0;
  display: flex;
}
</style>
